import { useState } from 'react';

import { AccordionChangeHandler } from './types';

export const useFAQAccordionState = (slug: string) => {
  const [expandedState, setExpandedState] = useState<string[]>([]);

  const handleAccordionChange: AccordionChangeHandler = (
    _question,
    isExpanded,
    changedSlug
  ) => {
    if (slug !== changedSlug) {
      return;
    }

    const isPrevExpanded = expandedState.includes(slug);

    if (isExpanded && !isPrevExpanded) {
      setExpandedState([...expandedState, slug]);
      return;
    }

    if (!isExpanded && isPrevExpanded) {
      setExpandedState(expandedState.filter((item) => item !== slug));
      return;
    }
  };

  const expandFaqItem = (slug: string) => {
    if (expandedState.includes(slug)) {
      return;
    }

    setExpandedState([...expandedState, slug]);
  };

  return {
    expandedState,
    handleAccordionChange,
    expandFaqItem,
  };
};
